// Bilingual dictionary: Spanish (es) + Euskera (eu)
export const translations = {
  es: {
    nav: {
      services: "Servicios",
      about: "Sobre nosotros",
      booking: "Reservar",
      contact: "Contacto",
      admin: "Acceso",
    },
    hero: {
      kicker: "Munguía · Bizkaia",
      title: "Soluciones completas para tu hogar",
      subtitle:
        "Recogida de basuras puerta a puerta, jardinería y mantenimiento de viviendas. Profesionales locales, atención cercana, de lunes a domingo.",
      ctaQuote: "Pedir presupuesto",
      ctaBooking: "Reservar servicio",
    },
    smallLabels: {
      services: "Nuestros servicios",
      about: "Por qué Ruizcare",
      booking: "Reserva online",
      contact: "Hablamos",
    },
    services: {
      title: "Tres servicios. Un mismo cuidado.",
      subtitle: "Atendemos Munguía y alrededores con dedicación artesanal.",
      garbage: {
        title: "Recogida de basuras puerta a puerta",
        desc: "Pasamos a recoger tus residuos en la puerta de casa, con horarios cómodos y respeto absoluto al reciclaje.",
      },
      gardening: {
        title: "Jardinería",
        desc: "Podas, mantenimiento de césped, setos y zonas verdes. Dejamos tu jardín vivo y bien cuidado.",
      },
      maintenance: {
        title: "Mantenimiento de viviendas",
        desc: "Pequeñas reparaciones, fontanería, pintura, electricidad básica y todo lo que tu casa necesite.",
      },
    },
    about: {
      title: "Cerca, accesibles y de Munguía.",
      p1: "Ruizcare nació para hacerte la vida más fácil. Somos un equipo local que combina tres oficios que muchas casas necesitan a diario.",
      p2: "Nos avala la cercanía. Nos avala el horario. Nos avala que somos vecinos.",
      bullets: [
        "Equipo local en Munguía",
        "Atención de Lunes a Domingo, 6:00 — 23:00",
        "Servicio puerta a puerta",
        "Trato cercano y honesto",
      ],
    },
    booking: {
      title: "Reserva tu servicio",
      subtitle: "Elige día y hora. Te confirmamos por teléfono o WhatsApp.",
      name: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      service: "Servicio",
      pickService: "Selecciona un servicio",
      date: "Fecha",
      pickDate: "Selecciona una fecha",
      time: "Hora",
      address: "Dirección",
      notes: "Notas (opcional)",
      submit: "Confirmar reserva",
      sending: "Enviando...",
      success: "¡Reserva enviada! Te contactaremos en breve.",
      error: "No pudimos enviar la reserva. Inténtalo de nuevo.",
    },
    quote: {
      title: "Pide tu presupuesto sin compromiso",
      subtitle: "Cuéntanos qué necesitas y te respondemos enseguida.",
      name: "Nombre",
      email: "Email",
      phone: "Teléfono",
      service: "Servicio de interés",
      message: "Cuéntanos qué necesitas",
      submit: "Enviar solicitud",
      sending: "Enviando...",
      success: "¡Solicitud recibida! Te llamaremos pronto.",
      error: "No pudimos enviar la solicitud. Inténtalo de nuevo.",
    },
    contact: {
      title: "Visítanos en Munguía",
      phone: "Teléfono / WhatsApp",
      email: "Email",
      address: "Dirección",
      hours: "Horario",
      hoursValue: "Lun – Dom · 6:00 — 23:00",
      addressValue: "Munguía, Bizkaia",
    },
    serviceKeys: {
      recogida_basuras: "Recogida de basuras",
      jardineria: "Jardinería",
      mantenimiento: "Mantenimiento de viviendas",
      otro: "Otro / Consulta",
    },
    footer: {
      tagline: "Soluciones completas para tu hogar",
      rights: "Todos los derechos reservados",
      legal: "Aviso legal",
      privacy: "Privacidad",
    },
    status: {
      pending: "Pendiente",
      contacted: "Contactado",
      confirmed: "Confirmado",
      completed: "Completado",
      cancelled: "Cancelado",
    },
    admin: {
      loginTitle: "Acceso administrador",
      loginSubtitle: "Gestiona presupuestos y reservas",
      email: "Email",
      password: "Contraseña",
      login: "Entrar",
      logout: "Cerrar sesión",
      dashboard: "Panel de control",
      stats: {
        quotes: "Presupuestos",
        bookings: "Reservas",
        pending: "Pendientes",
      },
      tabs: { quotes: "Solicitudes de presupuesto", bookings: "Reservas" },
      empty: "No hay registros todavía.",
      changeStatus: "Cambiar estado",
      delete: "Eliminar",
      loginError: "Credenciales incorrectas",
    },
    common: {
      requiredField: "Campo requerido",
      back: "Volver",
    },
  },
  eu: {
    nav: {
      services: "Zerbitzuak",
      about: "Guri buruz",
      booking: "Erreserbatu",
      contact: "Harremana",
      admin: "Sarrera",
    },
    hero: {
      kicker: "Mungia · Bizkaia",
      title: "Zure etxerako konponbide osoak",
      subtitle:
        "Atez ateko zaborren bilketa, lorezaintza eta etxebizitzen mantentzea. Bertako profesionalak, hurbileko arreta, astelehenetik igandera.",
      ctaQuote: "Aurrekontua eskatu",
      ctaBooking: "Zerbitzua erreserbatu",
    },
    smallLabels: {
      services: "Gure zerbitzuak",
      about: "Zergatik Ruizcare",
      booking: "Online erreserba",
      contact: "Hitz egin dezagun",
    },
    services: {
      title: "Hiru zerbitzu. Arreta bera.",
      subtitle: "Mungia eta inguruak zaintzen ditugu artisau-zaintzaz.",
      garbage: {
        title: "Atez ateko zaborren bilketa",
        desc: "Zure etxeko atean jasotzen ditugu hondakinak, ordutegi erosoekin eta birziklapenari erabateko begirunearekin.",
      },
      gardening: {
        title: "Lorezaintza",
        desc: "Inausketak, soropilaren mantenua, hesiak eta gune berdeak. Zure lorategia bizirik eta zainduta uzten dugu.",
      },
      maintenance: {
        title: "Etxebizitzen mantentzea",
        desc: "Konponketa txikiak, iturgintza, pintura, oinarrizko elektrizitatea eta etxeak behar duen guztia.",
      },
    },
    about: {
      title: "Hurbil, eskuragarri eta Mungiakoak.",
      p1: "Ruizcare zure bizitza errazteko sortu zen. Talde lokala gara, etxe askok egunero behar dituzten hiru lanbide konbinatzen ditugu.",
      p2: "Hurbiltasunak balioesten gaitu. Ordutegiak balioesten gaitu. Auzokoak garela balioesten gaitu.",
      bullets: [
        "Talde lokala Mungian",
        "Arreta Astelehenetik Igandera, 6:00 — 23:00",
        "Atez ateko zerbitzua",
        "Tratu hurbila eta zintzoa",
      ],
    },
    booking: {
      title: "Zure zerbitzua erreserbatu",
      subtitle: "Aukeratu eguna eta ordua. Telefonoz edo WhatsApp bidez berretsiko dizugu.",
      name: "Izen-abizenak",
      email: "Posta elektronikoa",
      phone: "Telefonoa",
      service: "Zerbitzua",
      pickService: "Aukeratu zerbitzu bat",
      date: "Eguna",
      pickDate: "Aukeratu eguna",
      time: "Ordua",
      address: "Helbidea",
      notes: "Oharrak (aukerakoa)",
      submit: "Erreserba berretsi",
      sending: "Bidaltzen...",
      success: "Erreserba bidalita! Laster jarriko gara harremanetan.",
      error: "Ezin izan dugu erreserba bidali. Saiatu berriro.",
    },
    quote: {
      title: "Eskatu aurrekontua konpromisorik gabe",
      subtitle: "Esan zer behar duzun eta berehala erantzungo dizugu.",
      name: "Izena",
      email: "Email",
      phone: "Telefonoa",
      service: "Interesatzen zaizun zerbitzua",
      message: "Esan zer behar duzun",
      submit: "Eskaera bidali",
      sending: "Bidaltzen...",
      success: "Eskaera jasota! Laster deituko dizugu.",
      error: "Ezin izan dugu eskaera bidali. Saiatu berriro.",
    },
    contact: {
      title: "Bisitatu gaitzazu Mungian",
      phone: "Telefonoa / WhatsApp",
      email: "Email",
      address: "Helbidea",
      hours: "Ordutegia",
      hoursValue: "Al – Ig · 6:00 — 23:00",
      addressValue: "Mungia, Bizkaia",
    },
    serviceKeys: {
      recogida_basuras: "Zaborren bilketa",
      jardineria: "Lorezaintza",
      mantenimiento: "Etxebizitzen mantentzea",
      otro: "Beste bat / Galdera",
    },
    footer: {
      tagline: "Zure etxerako konponbide osoak",
      rights: "Eskubide guztiak erreserbatuta",
      legal: "Lege oharra",
      privacy: "Pribatutasuna",
    },
    status: {
      pending: "Zain",
      contacted: "Kontaktatuta",
      confirmed: "Berretsia",
      completed: "Bukatua",
      cancelled: "Bertan behera",
    },
    admin: {
      loginTitle: "Administratzaile sarrera",
      loginSubtitle: "Aurrekontu eta erreserbak kudeatu",
      email: "Email",
      password: "Pasahitza",
      login: "Sartu",
      logout: "Itxi saioa",
      dashboard: "Kontrol panela",
      stats: { quotes: "Aurrekontuak", bookings: "Erreserbak", pending: "Zain daudenak" },
      tabs: { quotes: "Aurrekontu eskaerak", bookings: "Erreserbak" },
      empty: "Oraindik ez dago erregistrorik.",
      changeStatus: "Egoera aldatu",
      delete: "Ezabatu",
      loginError: "Kredentzial okerrak",
    },
    common: {
      requiredField: "Eremu beharrezkoa",
      back: "Itzuli",
    },
  },
};

export const SERVICE_OPTIONS = ["recogida_basuras", "jardineria", "mantenimiento", "otro"];
export const TIME_SLOTS = [
  "06:00","07:00","08:00","09:00","10:00","11:00","12:00","13:00",
  "14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00",
];
